/**
 * NPT-2264 — the hotel's pin: the same teardrop as the event/search flag (EventPinGraphic), in the
 * org's colour, with a bed in a white disc, so the two pins read as a pair rather than two
 * unrelated markers of different sizes. The tip is the bottom of the box: anchor it at 'bottom'.
 */
const HotelPinGraphic = ({ size = 40 }: { size?: number }) => (
   <svg width={size} height={(size * 48) / 40} viewBox="0 0 40 48" aria-hidden="true" className="text-orgPrimary">
      <path d="M20 47C20 47 37 30.5 37 18.5C37 9.11 29.39 1.5 20 1.5C10.61 1.5 3 9.11 3 18.5C3 30.5 20 47 20 47Z" fill="currentColor" stroke="#fff" strokeWidth="3" />
      <circle cx="20" cy="18.5" r="11" fill="#fff" />
      {/* A sleeper in bed: headboard, head on the pillow, body under the blanket, mattress and foot. */}
      <g fill="currentColor">
         <rect x="11.5" y="13" width="2" height="11" rx="0.6" />
         <circle cx="16.4" cy="17.2" r="1.9" />
         <rect x="18.8" y="15.6" width="9.2" height="3.6" rx="1.2" />
         <rect x="11.5" y="19.8" width="17" height="2.6" rx="0.6" />
         <rect x="26.5" y="19.8" width="2" height="4.2" rx="0.6" />
      </g>
   </svg>
);

export default HotelPinGraphic;
